module.exports = __webpack_public_path__ + "media/images/icon/navigation/account-active-70574a1e601e1fa7b1eebf95ac012b66.svg";